import { chainOrSuspend, pyNone } from "@Sk";
import PyDefUtils from "PyDefUtils";
import { AnvilHookSpec, Component, ComponentConstructor, DropZone } from "@runtime/components/Component";
import { BASE_MODULES } from "../python-environment";

const { DesignDataRowPanel, DataRowPanel } = BASE_MODULES["anvil"];

const mkDesignerHookSpec = (oldHookSpec: AnvilHookSpec): Partial<AnvilHookSpec> => {
    return {
        disableDropMode() {
            const dropZoneElements = this._anvil.dropZoneElements;
            for (const dz of dropZoneElements) {
                dz.remove();
            }
            dropZoneElements.length = 0;
        },
        enableDropMode() {
            this.anvil$hooks.disableDropMode!();
            const dropZoneElements = this._anvil.dropZoneElements;
            const componentsByColId: { [id: string]: { childIdx: number; component: Component }[] } = {};
            (this._anvil.components as { component: Component; layoutProperties: { column?: string } }[]).forEach(
                ({ component, layoutProperties: { column } }, childIdx) => {
                    (componentsByColId[column || ""] ||= []).push({ component, childIdx });
                }
            );

            const dropZones: DropZone[] = [];
            const mkDropZone = (colId: string, childIdx?: number) => {
                const element = document.createElement("div");
                dropZoneElements.push(element);
                const dz = {
                    element,
                    dropInfo: { childIdx, layout_properties: colId ? { column: colId } : {} },
                };
                dropZones.push(dz);
                return dz;
            };
            const colsAndDefault = Object.entries(this._anvil.cols as { [id: string]: { colEl: HTMLElement } }).concat([
                ["", { colEl: this._anvil.element[0] }],
            ]);
            for (const [colId, col] of colsAndDefault) {
                let hasComponents = false;
                for (const { component, childIdx } of componentsByColId[colId] || []) {
                    const dz = mkDropZone(colId, childIdx);
                    component.anvil$hooks.domElement!.insertAdjacentElement("beforebegin", dz.element);
                    hasComponents = true;
                }
                if (hasComponents || !colId) {
                    const dz = mkDropZone(colId);
                    if (!colId) {
                        dz.element.style.width = "100%";
                    }
                    col.colEl.insertAdjacentElement("beforeend", dz.element);
                } else {
                    dropZones.push({
                        element: col.colEl,
                        dropInfo: { layout_properties: colId ? { column: colId } : {} },
                    });
                }
            }
            return dropZones;
        },
    };
};

export const DesignDataRowPanelV3 = Sk.misceval.buildClass(
    BASE_MODULES["anvil"],
    function ($gbl, $loc) {
        $loc["__init__"] = PyDefUtils.funcFastCall(([self]: [Component], kws) =>
            chainOrSuspend(DesignDataRowPanel.prototype.tp$init.call(self, [], kws), () => {
                self._anvil.dropZoneElements = [] as HTMLElement[];
                return pyNone;
            })
        );
        const oldHookSpec = DataRowPanel.prototype.anvil$hookSpec;
        $loc.anvil$hookSpec = Object.assign(Object.create(oldHookSpec), mkDesignerHookSpec(oldHookSpec));
    },
    "DesignDataRowPanelV3",
    [DesignDataRowPanel]
) as ComponentConstructor;
